// extracted by mini-css-extract-plugin
module.exports = {"layout":"styles_layout__3q3TN","sidebar":"styles_sidebar__1OGr6","content":"styles_content__2Q3fN","cards":"styles_cards__1J4Ka","card":"styles_card__3CmNq"};